import React from "react";
import ImageWithFallback from "./ImageWithFallback";
import ApiRequest, { baseurl } from "../Common/restservice";
import { Link, useNavigate } from "react-router-dom";
import { errorToast, successToast } from "../Common/showtoast";

function IndividualGrid({ item }) {
  const navigate = useNavigate();
  const AddToFavourites = async (e) => {
    e.preventDefault();
    let res = await ApiRequest(
      "AddtoWishList.asp",
      "POST",
      JSON.stringify({ profileid: item.memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        navigate("/");
      }
      return;
    }
    successToast(res.message);
  };
  return (
    <div className="card overflow-hidden">
      <div
        className="item-card9-img"
        style={{
          height: 250,
          alignItems: "center",
          display: "flex",
        }}
      >
        <ImageWithFallback
          src={baseurl + item.profilepic}
          alt="img"
          className="cover-image"
          style={{height:"100%"}}
        />
      </div>
      <div className="item-card2-icons">
        <Link
          to={`/${
            item.usertypecategory === "Individual" ? "individual" : "company"
          }/${item.memberid}`}
          className="item-card2-icons-l bg-primary"
          title="View"
        >
          <i className="fa fa-eye"></i>
        </Link>
        <a href="#"
          onClick={AddToFavourites}
          className="item-card2-icons-r bg-pink"
          title="Save to Favourites"
        >
          <i className="fa fa fa-heart-o"></i>
        </a>
      </div>
      <div className="card-body pb-0">
        <div className="item-card2">
          <div className="item-card2-desc">
            <div className="item-card2-text">
              <Link
                to={`/${
                  item.usertypecategory === "Individual"
                    ? "individual"
                    : "company"
                }/${item.memberid}`}
                className="text-dark"
              >
                <h4 className="mb-0">{item.fullname}</h4>
              </Link>
            </div>
            <div className="d-flex">
              <Link
                to={`/${
                  item.usertypecategory === "Individual"
                    ? "individual"
                    : "company"
                }/${item.memberid}`}
              >
                <p className="pb-0 pt-0 mb-2 mt-2">
                  <i className="fa fa-map-marker text-danger me-2"></i>
                  {item.city || item.currentcity}
                </p>
              </Link>
              <span className="ms-3 pb-0 pt-0 mb-2 mt-2">
                <i className="fa fa-money text-danger me-2"></i>
                {item.pricing}
              </span>
            </div>
            <p className="">
              {item.industry || "-"}
            </p>
          </div>
        </div>
      </div>
      <div className="card-footer">
        <div className="item-card2-footer">
          <div className="item-card2-footer-u">
            <div className="d-md-flex ">
              <span className="review_score me-2 badge badge-primary">
                {item.avg_star_rating} / 5
              </span>
              <div className=" d-inline-flex">
                <div className="rating-star sm my-rating-5">
                  {[1, 2, 3, 4, 5].map((item1) => {
                    return item.avg_star_rating &&
                      parseInt(item.avg_star_rating) >= item1 ? (
                      <i key={item1} class="fa fa-star text-warning"></i>
                    ) : (
                      <i key={item1} class="fa fa-star text-muted"></i>
                    );
                  })}
                </div>
                ({item.number_of_review} Reviews)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndividualGrid;
